import { StatusDot } from "../renderers/StatusDot";

const fontDef = {
  fontFamily: "Poppins, sans-serif",
  fontSize: "15px",
  lineHeight: "1.5",
};

export const formatToK = (num) => {
  if (num >= 1_000_000_000) return (num / 1_000_000_000).toFixed(1).replace(/\.0$/, "") + "G";
  if (num >= 1_000_000) return (num / 1_000_000).toFixed(1).replace(/\.0$/, "") + "M";
  if (num >= 1_000) return (num / 1_000).toFixed(1).replace(/\.0$/, "") + "K";
  return num;
};

export const formatTo2Decimals = (num, minDecimals = 2, maxDecimals = 2) => {
  if (num === null || num === undefined || isNaN(num)) return "0.00";
  return Number(num).toLocaleString("en-CA", {
    minimumFractionDigits: minDecimals,
    maximumFractionDigits: maxDecimals,
  });
};
export const defaultColDef = {
  filter: false,
  initialFlex: 1,
  wrapText: false,
  autoHeight: false,
  wrapHeaderText: true,
  autoHeaderHeight: true,
  editable: false,
  minWidth: 250,
  suppressMovable: false,
  tooltipValueGetter: (params) => params.value,
  tooltipComponent: 'customTooltip',
};

// Header cells are always centred (AGENTS.md section 4); only the data cells follow the
// column's alignment: text left, numbers right, years/dates centre.
const CENTER_HEADER_CLASS = "ag-center-aligned-header";

export const leftAlignColDef = {
  headerClass: CENTER_HEADER_CLASS,
  cellStyle: {
    ...fontDef,
    textAlign: "left",
    justifyContent: "flex-start",
    paddingLeft: "20px",
  },
};
export const centerAlignColDef = {
  headerClass: CENTER_HEADER_CLASS,
  cellStyle: {
    ...fontDef,
    textAlign: "center",
    justifyContent: "center",
    paddingLeft: "15px",
    paddingRight: "15px",
  },
};
export const rightAlignColDef = {
  headerClass: CENTER_HEADER_CLASS,
  cellStyle: {
    ...fontDef,
    textAlign: "right",
    justifyContent: "flex-end",
    paddingRight: "20px",
  },
};
export const floatFormater = {
  valueFormatter: (params) => {
    const value = params.value === null ? NaN : Number(params.value);
    return isNaN(value)
      ? "0.00"
      : value.toLocaleString("en-CA", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
  },
};
// Aliases kept for existing imports; all three formatted identically.
export const nullableFloatFormater = floatFormater;
export const exactFloatFormater = floatFormater;

export const translationFormater = (t) => ({
  valueFormatter: (params) => {
    return t(params.value);
  },
});
export const checkBoxColDef = {
  ...defaultColDef,
  ...centerAlignColDef,
  cellRenderer: StatusDot,
};

export const float4Formater = {
  valueFormatter: (params) => {
    const value = params.value === null ? NaN : Number(params.value);
    return isNaN(value)
      ? "0.0000"
      : value.toLocaleString("en-CA", {
        minimumFractionDigits: 4,
        maximumFractionDigits: 4,
      });
  },
};

export const tonsFormatter = {
  valueFormatter: (params) => {
    const value = params.value === null ? NaN : Number(params.value) / 1000;
    return isNaN(value)
      ? "0.00"
      : value.toLocaleString("en-CA", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
  },
};
